"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var INSERTER_COLOR = '#4A4A4A';
var INSERTER_SIDE_LENGTH = 12;
var INSERTER_BORDER_SIZE = 1;
var CELL_RESIZER_WIDTH = 4;
var HORIZONTAL_RESIZER_HTML = '<div style="position: fixed; cursor: row-resize; user-select: none"></div>';
var VERTICAL_RESIZER_HTML = '<div style="position: fixed; cursor: col-resize; user-select: none"></div>';
var ResizeState;
(function (ResizeState) {
    ResizeState[ResizeState["None"] = 0] = "None";
    ResizeState[ResizeState["Horizontal"] = 1] = "Horizontal";
    ResizeState[ResizeState["Vertical"] = 2] = "Vertical";
})(ResizeState || (ResizeState = {}));
/**
 * TableResize plugin, provides the ability to resize a table by drag-and-drop
 */
var TableResize = /** @class */ (function () {
    function TableResize() {
        var _this = this;
        this.tableRectMap = null;
        this.resizingState = 0 /* None */;
        this.insertingState = 0 /* None */;
        this.onMouseMove = function (e) {
            if (_this.resizingState != 0 /* None */) {
                return;
            }
            if (!_this.tableRectMap) {
                _this.cacheRects();
            }
            if (_this.tableRectMap) {
                var i = _this.tableRectMap.length - 1;
                for (; i >= 0; i--) {
                    var _a = _this.tableRectMap[i], table = _a.table, rect = _a.rect;
                    if (e.pageX >= rect.left - INSERTER_SIDE_LENGTH &&
                        e.pageX <= rect.right &&
                        e.pageY >= rect.top - INSERTER_SIDE_LENGTH &&
                        e.pageY <= rect.bottom) {
                        _this.setCurrentTable(table, rect);
                        break;
                    }
                }
                if (i < 0) {
                    _this.setCurrentTable(null);
                }
                if (_this.currentTable) {
                    var map = _this.tableRectMap.filter(function (map) { return map.table == _this.currentTable; })[0];
                    for (var i_1 = 0; i_1 < _this.currentTable.rows.length; i_1++) {
                        var tr = _this.currentTable.rows[i_1];
                        var j = 0;
                        for (; j < tr.cells.length; j++) {
                            var td = tr.cells[Math.max(0, j)];
                            var tdRect = roosterjs_editor_dom_1.normalizeRect(td.getBoundingClientRect());
                            if (e.pageX <= tdRect.right && e.pageY < tdRect.bottom) {
                                if (i_1 == 0 && e.pageY < tdRect.top) {
                                    _this.setCurrentTd(null);
                                    _this.setCurrentInsertTd(2 /* Vertical */, td, map.rect);
                                    break;
                                }
                                else if (j == 0 && e.pageX < tdRect.left) {
                                    _this.setCurrentTd(null);
                                    _this.setCurrentInsertTd(1 /* Horizontal */, td, map.rect);
                                    break;
                                }
                                else {
                                    _this.setCurrentTd(td, map.rect, tdRect.right, tdRect.bottom);
                                    _this.setCurrentInsertTd(0 /* None */);
                                    break;
                                }
                            }
                        }
                        if (j < tr.cells.length) {
                            break;
                        }
                    }
                }
            }
        };
        this.insertTd = function () {
            _this.editor.addUndoSnapshot(function (start, end) {
                var vtable = new roosterjs_editor_dom_1.VTable(_this.currentInsertTd);
                vtable.edit(_this.insertingState == 1 /* Horizontal */
                    ? 1 /* InsertBelow */
                    : 3 /* InsertRight */);
                vtable.writeBack();
                _this.editor.select(start, end);
                _this.setCurrentInsertTd(0 /* None */);
            }, "Format" /* Format */);
        };
        this.startHorizontalResizeTable = function (e) {
            _this.resizingState = 1 /* Horizontal */;
            _this.startResizeTable(e);
        };
        this.startVerticalResizeTable = function (e) {
            _this.resizingState = 2 /* Vertical */;
            _this.startResizeTable(e);
        };
        this.frameAnimateResizeTable = function (e) {
            _this.editor.runAsync(function () { return _this.resizeTable(e); });
        };
        this.resizeTable = function (e) {
            if (_this.currentTd) {
                var rect_1 = roosterjs_editor_dom_1.normalizeRect(_this.currentTd.getBoundingClientRect());
                var newPos_1 = _this.resizingState == 1 /* Horizontal */ ? e.pageY : e.pageX;
                var vtable = new roosterjs_editor_dom_1.VTable(_this.currentTd);
                if (_this.resizingState == 1 /* Horizontal */) {
                    vtable.table.style.height = null;
                    vtable.forEachCellOfCurrentRow(function (cell) {
                        if (cell.td) {
                            cell.td.style.height =
                                cell.td == _this.currentTd ? newPos_1 - rect_1.top + "px" : null;
                        }
                    });
                }
                else {
                    vtable.table.style.width = '';
                    vtable.table.width = '';
                    vtable.forEachCellOfCurrentColumn(function (cell) {
                        if (cell.td) {
                            cell.td.style.width =
                                cell.td == _this.currentTd ? newPos_1 - rect_1.left + "px" : null;
                        }
                    });
                }
                vtable.writeBack();
            }
        };
        this.endResizeTable = function (e) {
            var doc = _this.editor.getDocument();
            doc.removeEventListener('mousemove', _this.frameAnimateResizeTable, true);
            doc.removeEventListener('mouseup', _this.endResizeTable, true);
            _this.editor.addUndoSnapshot(function (start, end) {
                _this.frameAnimateResizeTable(e);
                _this.editor.select(start, end);
            }, "Format" /* Format */);
            _this.setCurrentTd(null);
            _this.resizingState = 0 /* None */;
        };
    }
    /**
     * Get a friendly name of  this plugin
     */
    TableResize.prototype.getName = function () {
        return 'TableResize';
    };
    /**
     * Initialize this plugin. This should only be called from Editor
     * @param editor Editor instance
     */
    TableResize.prototype.initialize = function (editor) {
        this.editor = editor;
        this.setupResizerContainer();
        this.onMouseMoveDisposer = this.editor.addDomEventHandler('mousemove', this.onMouseMove);
    };
    /**
     * Dispose this plugin
     */
    TableResize.prototype.dispose = function () {
        this.onMouseMoveDisposer();
        this.destoryRectMap();
        this.removeResizerContainer();
        this.editor = null;
    };
    /**
    * Handle events triggered from editor
    * @param event PluginEvent object
    */
    TableResize.prototype.onPluginEvent = function (e) {
        switch (e.eventType) {
            case 12 /* Input */:
            case 6 /* ContentChanged */:
            case 15 /* Scroll */:
                this.destoryRectMap();
                break;
        }
    };
    TableResize.prototype.setupResizerContainer = function () {
        this.resizerContainer = this.editor.getDocument().createElement('div');
        this.editor.insertNode(this.resizerContainer, {
            updateCursor: false,
            insertOnNewLine: false,
            replaceSelection: false,
            position: 4 /* Outside */,
        });
    };
    TableResize.prototype.removeResizerContainer = function () {
        this.resizerContainer.parentNode.removeChild(this.resizerContainer);
        this.resizerContainer = null;
    };
    TableResize.prototype.setCurrentInsertTd = function (insertingState, td, tableRect) {
        if (td != this.currentInsertTd || insertingState != this.insertingState) {
            if (this.currentInsertTd) {
                this.resizerContainer.removeChild(this.inserter);
                this.inserter = null;
            }
            this.insertingState = insertingState;
            this.currentInsertTd = td;
            if (this.currentInsertTd) {
                this.inserter = this.createInserter(tableRect);
                this.resizerContainer.appendChild(this.inserter);
            }
        }
    };
    TableResize.prototype.createInserter = function (tableRect) {
        var rect = roosterjs_editor_dom_1.normalizeRect(this.currentInsertTd.getBoundingClientRect());
        var editorBackgroundColor = this.editor.getDefaultFormat().backgroundColor;
        var inserterBackgroundColor = editorBackgroundColor || 'white';
        var HORIZONTAL_INSERTER_HTML = "<div style=\"position: fixed; width: " + INSERTER_SIDE_LENGTH + "px; height: " + INSERTER_SIDE_LENGTH + "px; font-size: 16px; color: " + INSERTER_COLOR + "; line-height: 10px; vertical-align: middle; text-align: center; cursor: pointer; border: solid " + INSERTER_BORDER_SIZE + "px " + INSERTER_COLOR + "; border-radius: 50%; background-color: " + inserterBackgroundColor + "\"><div style=\"position: absolute; left: 12px; top: 5px; height: 3px; border-top: 1px solid " + INSERTER_COLOR + "; border-bottom: 1px solid " + INSERTER_COLOR + "; border-right: 1px solid " + INSERTER_COLOR + "; border-left: 0px; box-sizing: border-box; background-color: " + inserterBackgroundColor + ";\"></div>+</div>";
        var VERTICAL_INSERTER_HTML = "<div style=\"position: fixed; width: " + INSERTER_SIDE_LENGTH + "px; height: " + INSERTER_SIDE_LENGTH + "px; font-size: 16px; color: " + INSERTER_COLOR + "; line-height: 10px; vertical-align: middle; text-align: center; cursor: pointer; border: solid " + INSERTER_BORDER_SIZE + "px " + INSERTER_COLOR + "; border-radius: 50%; background-color: " + inserterBackgroundColor + "\"><div style=\"position: absolute; left: 5px; top: 12px; width: 3px; border-left: 1px solid " + INSERTER_COLOR + "; border-right: 1px solid " + INSERTER_COLOR + "; border-bottom: 1px solid " + INSERTER_COLOR + "; border-top: 0px; box-sizing: border-box; background-color: " + inserterBackgroundColor + ";\"></div>+</div>";
        var inserter = roosterjs_editor_dom_1.fromHtml(this.insertingState == 1 /* Horizontal */
            ? HORIZONTAL_INSERTER_HTML
            : VERTICAL_INSERTER_HTML, this.editor.getDocument())[0];
        if (this.insertingState == 1 /* Horizontal */) {
            inserter.style.left = rect.left -
                (INSERTER_SIDE_LENGTH - 1 + 2 * INSERTER_BORDER_SIZE) + "px";
            inserter.style.top = rect.bottom - 8 + "px";
            inserter.firstChild.style.width = tableRect.right -
                tableRect.left + "px";
        }
        else {
            inserter.style.left = rect.right - 8 + "px";
            inserter.style.top = rect.top -
                (INSERTER_SIDE_LENGTH - 1 + 2 * INSERTER_BORDER_SIZE) + "px";
            inserter.firstChild.style.height = tableRect.bottom -
                tableRect.top + "px";
        }
        inserter.addEventListener('click', this.insertTd);
        return inserter;
    };
    TableResize.prototype.setCurrentTable = function (table, rect) {
        if (this.currentTable != table) {
            this.setCurrentTd(null);
            this.setCurrentInsertTd(null);
            this.currentTable = table;
        }
    };
    TableResize.prototype.setCurrentTd = function (td, tableRect, right, bottom) {
        if (this.currentTd != td) {
            if (this.currentTd) {
                this.resizerContainer.removeChild(this.horizontalResizer);
                this.resizerContainer.removeChild(this.verticalResizer);
                this.horizontalResizer = null;
                this.verticalResizer = null;
            }
            this.currentTd = td;
            if (this.currentTd) {
                this.horizontalResizer = this.createResizer(true /*horizontal*/, tableRect.left, bottom - CELL_RESIZER_WIDTH + 1, tableRect.right - tableRect.left, CELL_RESIZER_WIDTH);
                this.verticalResizer = this.createResizer(false /*horizontal*/, right - CELL_RESIZER_WIDTH + 1, tableRect.top, CELL_RESIZER_WIDTH, tableRect.bottom - tableRect.top);
                this.resizerContainer.appendChild(this.horizontalResizer);
                this.resizerContainer.appendChild(this.verticalResizer);
            }
        }
    };
    TableResize.prototype.createResizer = function (horizontal, left, top, width, height) {
        var div = roosterjs_editor_dom_1.fromHtml(horizontal ? HORIZONTAL_RESIZER_HTML : VERTICAL_RESIZER_HTML, this.editor.getDocument())[0];
        div.style.top = top + "px";
        div.style.left = left + "px";
        div.style.width = width + "px";
        div.style.height = height + "px";
        div.addEventListener('mousedown', horizontal ? this.startHorizontalResizeTable : this.startVerticalResizeTable);
        return div;
    };
    TableResize.prototype.startResizeTable = function (e) {
        var doc = this.editor.getDocument();
        doc.addEventListener('mousemove', this.frameAnimateResizeTable, true);
        doc.addEventListener('mouseup', this.endResizeTable, true);
    };
    TableResize.prototype.destoryRectMap = function () {
        this.setCurrentTable(null);
        this.tableRectMap = null;
    };
    TableResize.prototype.cacheRects = function () {
        var _this = this;
        this.destoryRectMap();
        this.tableRectMap = [];
        this.editor.queryElements('table', function (table) {
            var rect = roosterjs_editor_dom_1.normalizeRect(table.getBoundingClientRect());
            if (rect) {
                _this.tableRectMap.push({
                    table: table,
                    rect: rect,
                });
            }
        });
    };
    return TableResize;
}());
exports.default = TableResize;
//# sourceMappingURL=TableResize.js.map